import { useEffect, useState } from 'react';

import { accessTokenState } from 'atoms';
import { useRecoilState } from 'recoil';

export const useWebviewSignIn = () => {
  const [accessToken, setAccessToken] = useRecoilState(accessTokenState);

  useEffect(() => {
    if (accessToken) {
      return;
    }

    if (!window || !window.ReactNativeWebView) {
      return;
    }

    window.addEventListener('message', signinWithAccessToken);

    return () => {
      window.removeEventListener('message', signinWithAccessToken);
    };

    function signinWithAccessToken(event: MessageEvent) {
      try {
        const parsedEventData = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        const onLoadEndEventType = 'signin-with-token';

        if (parsedEventData.type === onLoadEndEventType) {
          setAccessToken(parsedEventData?.data?.accessToken as string);
        }
      } catch (error) {
        console.debug(error);
        setAccessToken(undefined);
      }
    }
  }, [accessToken]);
};
